/* eslint-disable no-shadow */
/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useRef } from 'react';

import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import useNearScreen from '@hooks/useNearScreen';
import { useBreakpoints } from '@hooks/NewBreakpoint';
import { LoadingLastMovements } from '@components';

import { theme, Icon } from 'fpay-ui';

const fontTypes = {
  pageNumber: css`
    ${({ theme }) => theme.textTypes['Caption-w500']};
    line-height: normal;
  `,
  nextPrev: css`
    ${({ theme }) => theme.textTypes['Caption-w400']};
    line-height: normal;
  `,
};

const PaginationContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const PaginationButton = styled.div(
  ({ theme, status }) => css`
    display: ${status === 'disabled' ? 'none' : 'flex'};
    width: ${(props) => (props.nextPrev ? '96px' : '32px')};
    height: 32px;
    border-radius: 4px;
    padding-left: ${(props) => (props.nextPrev ? '7px' : '')};
    padding-right: ${(props) => (props.onlyPrev ? '12px' : '')};
    box-shadow: ${(props) => (props.nextPrev ? '' : '0 3px 6px 0 rgba(0, 0, 0, 0.07)')};
    ${(props) => (props.nextPrev ? fontTypes.nextPrev : fontTypes.pageNumber)};
    justify-content: center;
    justify-items: center;
    align-items: center;
    color: ${(props) => (props.nextPrev ? `${theme.colors.gray700}` : `${theme.colors.gray800}`)};
    cursor: ${(props) => (props.current ? 'default' : 'pointer')};
    background-color: ${(props) => (props.nextPrev ? `${theme.colors.gray200}` : '#ffffff')};
    text-align: center;
    align-items: center;
    &:hover {
      box-shadow: ${(props) => (props.nextPrev ? '0 3px 6px 0 rgba(0, 0, 0, 0.07)' : '')};
      background-color: #ffffff;
    }
    margin-right: 16px;
    &:last-child {
      margin-right: 0px;
    }
  `
);

const ImagePrev = styled(Icon)(
  () => css`
    transform: rotate(180deg);
    width: 14px;
    height: 14px;
    fill: ${theme.colors.gray700};
  `
);

const ImageNext = styled(Icon)(
  () => css`
    width: 14px;
    height: 14px;
    fill: ${theme.colors.gray700};
  `
);

const PageOf = styled.div`
  ${fontTypes.nextPrev};
  color: ${theme.colors.gray700};
  margin-right: 16px;
`;

const PaginationMov = ({ itemsPerPage, movements, setData, infinityScroll, endScroll }) => {
  const externalRef = useRef();
  const { isNearScreen } = useNearScreen({
    externalRef,
    once: false,
  });
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);
  const { breakpoint } = useBreakpoints();
  const [loading, setLoading] = useState(null);

  const pages = Math.ceil(movements.length / itemsPerPage);

  const numberOfPages = [];
  for (let i = 1; i <= pages; i++) {
    numberOfPages.push(i);
  }
  const [currentButton, setCurrentButton] = useState(1);

  const [arrOfCurrButtons, setArrOfCurrButtons] = useState([]);

  useEffect(() => {
    setCurrentButton(1);
    // eslint-disable-next-line
  }, [pages]);

  useEffect(() => {
    const page =
      currentPage === 1
        ? [0, itemsPerPage]
        : [currentPage * itemsPerPage - itemsPerPage, currentPage * itemsPerPage];
    setData(movements.length < itemsPerPage ? [0, itemsPerPage] : page);
    // eslint-disable-next-line
  }, [currentPage, itemsPerPage]);

  useEffect(() => {
    const tempNumberOfPages = [...arrOfCurrButtons];
    setArrOfCurrButtons(tempNumberOfPages);
    setCurrentPage(currentButton);
    // eslint-disable-next-line
  }, [currentButton, movements]);

  useEffect(() => {
    !endScroll && setLoading(true);

    setTimeout(() => {
      if (isNearScreen)
        setData(
          movements.length < itemsPerPage
            ? [0, itemsPerPage]
            : [0, infinityScroll[1] + itemsPerPage],
          endScroll
        );
    }, 2000);
    // eslint-disable-next-line
  }, [isNearScreen]);

  useEffect(() => {
    endScroll && setLoading(false);
  }, [endScroll]);

  return breakpoint === 'xs' ? (
    <>
      <div id="visor" ref={externalRef} />
      {loading && <LoadingLastMovements />}
    </>
  ) : (
    <PaginationContainer data-testid="pagination-container">
      <PaginationButton
        status={`${currentButton === 1 && 'disabled'}`}
        onClick={() => setCurrentButton((prev) => (prev <= 1 ? prev : prev - 1))}
        data-testid="clickBack"
        nextPrev
        onlyPrev
      >
        <ImagePrev icon="ic_chevron_down_24" />
        {t('lastMovements.last')}
      </PaginationButton>
      <PaginationButton current>{currentButton}</PaginationButton>
      {pages !== 1 && <PageOf>de {pages}</PageOf>}

      <PaginationButton
        status={`${currentButton === numberOfPages.length && 'disabled'}`}
        onClick={() => setCurrentButton((prev) => (prev >= numberOfPages.length ? prev : prev + 1))}
        data-testid="clickNext"
        nextPrev
      >
        {t('lastMovements.next')}
        <ImageNext icon="ic_chevron_down_24" />
      </PaginationButton>
    </PaginationContainer>
  );
};

export default PaginationMov;
